import { render, staticRenderFns } from "./StatusDetail.vue?vue&type=template&id=39b0dcd5&scoped=true"
import script from "./StatusDetail.vue?vue&type=script&lang=js"
export * from "./StatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b0dcd5",
  null
  
)

export default component.exports